export * from './years-list.component';



// WEBPACK FOOTER //
// ./src/app/components/years-list/index.ts